module.exports = __webpack_public_path__ + "img/88.5d5e00ff.jpg";